// Components
import { Card, HeaderMenu, Loading } from "components"
import { Acc, AddReminder, Date, Deliver, Memo, PromisedDate, Supplier, SupplierId, TableSection, TaxInclusive, TradingTerm } from "../../components"
import { Code, Table } from "."

// Contexts
import { DataJournalContextProvider } from "contexts"
import { ReminderContext } from "../../contexts"
import { PurchaseOrderContext } from "../contexts"

// Form
import { FormProvider, useForm } from "react-hook-form"


// Utils
import { type FormType, DetailFormType } from "../utils"
import { useDetailBill } from "../utils/hooks/useDetailBill"
import { DetailBill, PayloadBillType } from "../types"

export function DetailDirectBill(params: {
  bill_id: string
}): JSX.Element {
  // Hooks
  const { data, isLoading } = useDetailBill(params.bill_id)

  if (isLoading || !data) {
    return (
      <Loading
        errorText="No data available"
        loading={isLoading}
      />
    )
  }

  return (
    <PurchaseOrderContext.Provider value={{ disabled: true }}>
      <FormSection
        data={data}
        bill_id={params.bill_id}
      />
    </PurchaseOrderContext.Provider>
  )
}

function FormSection(params: {
  data: PayloadBillType
  bill_id: string
}): JSX.Element {
  // Vars
    const { databill, detailbill } = params.data
    
    const mapDetailToForm = (detailbill: DetailBill[]): DetailFormType[] => {
        return detailbill.map((item) => ({
        discount: item.discount,
        mr_unit_id: String(item.unit_measure_id),
        price_bill: item.price_bill,
        product_id: String(item.product_id),
        project_id: String(item.project_id),
        quantity_bill: item.quantity_bill,
        quantity_unit: item.quantity_unit,
        tax_id: String(item.tax_id),
        total: item.total,
        vendor_description: item.vendor_description,
        description: item.vendor_description,
        }));
    };
  
    // Form
    const default_values = {
        purchase_order_id: 0,
        address: "",
        imgPath: [],
        trx_code: databill.trx_code,
        _vendor_name: databill.vendor_name ?? "",
        approval_status: databill.approve_status,
        freight: databill.freight,
        location_id: databill.location_id.toString(),
        memo: databill.memo,
        payment_term: "",
        promise_date: databill.promise_date,
        referensi: databill.referensi,
        tax_inclusive: true,
        transaction_date: databill.transaction_date,
        vendor_id: databill.vendor_id.toString(),  
        reminder: null,
        probildetail: mapDetailToForm(detailbill),
        delivery_no: databill.delivery_no,
    }
    const methods = useForm<FormType>({
        defaultValues: default_values
    })

  return (
    <FormProvider {...methods}>
      <section className="flex flex-col gap-2">
        <HeaderMenu 
            title="DATA ENTRY | DIRECT BILL"
            action="create"
            >
            <Code value={default_values.trx_code} />
        </HeaderMenu>

        <section className="grid lg:grid-cols-3 gap-x-6 gap-y-3 items-end">
          <Supplier
            disabled
            name="vendor_id"
            trading_term_name="payment_term"
            vendor_name="_vendor_name"
             detail="probildetail"
          />

          <TradingTerm name="payment_term" />
          <TaxInclusive name="tax_inclusive" />
        </section>

        <Card>
          <Card.Body className="grid lg:grid-cols-2 gap-x-6 gap-y-3">
            <section className="flex flex-col gap-3">
              <Deliver
                disabled
                deliver_name="location_id"
                detail_name="address"
              />

              <Memo
                disabled
                name="memo"
              />
            </section>

            <section className="flex flex-col gap-3">
                <Date
                    disabled
                    name="transaction_date"
                />

                <SupplierId
                    disabled
                    name="referensi"
                />

                <PromisedDate
                    disabled
                    name="promize_date"
                />

                <ReminderContext.Provider
                  value={{
                    disabled: false,
                    transaction_from: "DIRECT_BILL",
                    name: {
                      memo: "memo",
                      promise_date: "promize_date",
                      reminder: "reminder",
                      referensi: "referensi",
                      transaction_date: "transaction_date",
                      vendor_name: "_vendor_name",
                      reminder_child: {
                        memo: "reminder.memo",
                        promise_date: "reminder.promise_date",
                        transaction_date: "reminder.transaction_date"
                      }
                    },
                    onSuccess: (value) => {
                      methods.setValue("reminder.memo", value.memo)
                      methods.setValue("reminder.promise_date", value.promise_date)
                      methods.setValue("promise_date", value.promise_date)
                      methods.setValue("reminder.transaction_date", value.transaction_date)
                    }
                  }}
                >
                  <AddReminder />
                </ReminderContext.Provider>
            </section>
          </Card.Body>
        </Card>

        <DataJournalContextProvider>
          <Table />

          <section className="grid lg:grid-cols-2 gap-x-6 gap-y-3">
              <section className="flex flex-col gap-3">
              <TableSection>

                    <TableSection.Row
                    label="BILL STATUS"
                    value="-"
                    />

                    <TableSection.Row
                    label="APPROVAL STATUS"
                    value=''
                    />



                    <TableSection.Row
                    label="APPROVED BY"
                    value={databill.approve_by_name ?? '-'}
                    />
                </TableSection>

                {/* <RecurringButton /> */}
              </section>

              <Acc
                name={{
                  detail: "probildetail",
                  freight: "freight"
                }}
                disabled_freight={true}
              />
            </section>
        </DataJournalContextProvider>
 
      </section>
    </FormProvider>
  )
}
